import React, { Component } from "react";
import {
    BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
    ComposedChart
} from "recharts";
import { CommonLoader } from "../../../common/CommonLoader";
import { formatAmount } from "../../../../services/utils";

class CotisantStatsComparison extends Component {
    formatData = () => {
        const { data1, data2, fetchingNbrCotisantByFormat, nbrCotisantByFormatCompareFetch, activeTab, frequency, year, showAccumulateStats, visibleKeys, startMonth, endMonth } = this.props;

        if (frequency === "MONTHLY") {
            // build months list between startMonth and endMonth (inclusive)
            // startMonth/endMonth expected as "YYYY-MM"
            const shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

            const parseYearMonth = (ym) => {
                if (!ym) return null;
                const parts = ym.split('-');
                if (parts.length < 2) return null;
                return { year: parseInt(parts[0], 10), month: parseInt(parts[1], 10) };
            };

            const start = parseYearMonth(startMonth) || { year: year[0], month: 1 };
            const end = parseYearMonth(endMonth) || { year: year[0], month: 12 };

            // iterate months from start to end
            const monthsEntries = [];
            const cur = new Date(start.year, start.month - 1, 1);
            const endDate = new Date(end.year, end.month - 1, 1);
            while (cur <= endDate) {
                const y = cur.getFullYear();
                const m = cur.getMonth() + 1;
                monthsEntries.push({ year: y, month: (m < 10 ? '0' + m : '' + m), name: shortMonthNames[cur.getMonth()] });
                cur.setMonth(cur.getMonth() + 1);
            }

            return monthsEntries.map((entry) => {
                const key1 = `${entry.year}-${entry.month}`;
                const key2 = `${entry.year - 1}-${entry.month}`;

                const statutaire1 = Object.values(data1[key1] || {}).slice(0, 4).reduce((a, b) => a + b, 0);
                const fiduciaire1 = ((data1[key1] || {})[5] + ((data1[key1] || {})['ASSOCIATE'] || 0)) || 0;
                const statutaire2 = Object.values(data2[key2] || {}).slice(0, 4).reduce((a, b) => a + b, 0);
                const fiduciaire2 = ((data2[key2] || {})[5] + ((data2[key2] || {})['ASSOCIATE'] || 0)) || 0;
                const total1 = (visibleKeys.includes('Statutaire') ? Object.values(data1[key1] || {}).slice(0, 4).reduce((a, b) => a + b, 0) : 0) + (visibleKeys.includes('Fiduciaire') ? ((data1[key1] || {})[5] + ((data1[key1] || {})['ASSOCIATE'] || 0)) : 0);
                const total2 = (visibleKeys.includes('Statutaire') ? Object.values(data2[key2] || {}).slice(0, 4).reduce((a, b) => a + b, 0) : 0) + (visibleKeys.includes('Fiduciaire') ? ((data2[key2] || {})[5] + ((data2[key2] || {})['ASSOCIATE'] || 0)) : 0);
                return {
                    name: entry.name,
                    Statutaire1: activeTab === 'chiffreAffaire' ? statutaire1 / 100 : statutaire1,
                    Fiduciaire1: activeTab === 'chiffreAffaire' ? fiduciaire1 / 100 : fiduciaire1,
                    Statutaire2: activeTab === 'chiffreAffaire' ? statutaire2 / 100 : statutaire2,
                    Fiduciaire2: activeTab === 'chiffreAffaire' ? fiduciaire2 / 100 : fiduciaire2,
                    Total1: activeTab === 'chiffreAffaire' ? total1 / 100 : total1,
                    Total2: activeTab === 'chiffreAffaire' ? total2 / 100 : total2
                };
            });
        } else if (frequency === "DAILY") {
            let formattedData = [];
            const keys = Object.keys(data1);
            keys.forEach((key, index) => {
                const key2 = `${parseInt(key.split('-')[0], 10) - 1}-${key.split('-')[1]}-${key.split('-')[2]}`;
                const statutaire1 = showAccumulateStats ? (data1[key] || {})['statutaire'] || 0 : Object.values(data1[key] || {}).slice(0, 4).reduce((a, b) => a + b, 0);
                const fiduciaire1 = showAccumulateStats ? (data1[key] || {})['fiduciaire'] || 0 : ((data1[key] || {})[5] + (data1[key] || {})['ASSOCIATE']) || 0;
                const statutaire2 = showAccumulateStats ? (data2[key2] || {})['statutaire'] || 0 : Object.values(data2[key2] || {}).slice(0, 4).reduce((a, b) => a + b, 0);
                const fiduciaire2 = showAccumulateStats ? (data2[key2] || {})['fiduciaire'] || 0 : ((data2[key2] || {})[5] + (data2[key2] || {})['ASSOCIATE']) || 0;

                const total1 = showAccumulateStats ? ((visibleKeys.includes('Statutaire') ? ((data1[key] || {})['statutaire'] || 0) : 0) + (visibleKeys.includes('Fiduciaire') ? ((data1[key] || {})['fiduciaire'] || 0) : 0)) : ((visibleKeys.includes('Statutaire') ? Object.values(data1[key] || {}).slice(0, 4).reduce((a, b) => a + b, 0) : 0) + (visibleKeys.includes('Fiduciaire') ? ((data1[key] || {})[5] + (data1[key] || {})['ASSOCIATE'] || 0) : 0));
                const total2 = showAccumulateStats ? ((visibleKeys.includes('Statutaire') ? ((data2[key2] || {})['statutaire'] || 0) : 0) + (visibleKeys.includes('Fiduciaire') ? ((data2[key2] || {})['fiduciaire'] || 0) : 0)) : ((visibleKeys.includes('Statutaire') ? Object.values(data2[key2] || {}).slice(0, 4).reduce((a, b) => a + b, 0) : 0) + (visibleKeys.includes('Fiduciaire') ? ((data2[key2] || {})[5] + (data2[key2] || {})['ASSOCIATE'] || 0) : 0));
                const keys = key.split('-');

                formattedData.push({
                    name: keys[2] + '/' + keys[1], // Convert "YYYY-MM-DD" to "DD/MM"
                    Statutaire1: activeTab === 'chiffreAffaire' ? statutaire1 / 100 : statutaire1,
                    Fiduciaire1: activeTab === 'chiffreAffaire' ? fiduciaire1 / 100 : fiduciaire1,
                    Statutaire2: activeTab === 'chiffreAffaire' ? statutaire2 / 100 : statutaire2,
                    Fiduciaire2: activeTab === 'chiffreAffaire' ? fiduciaire2 / 100 : fiduciaire2,
                    Total1: activeTab === 'chiffreAffaire' ? total1 / 100 : total1,
                    Total2: activeTab === 'chiffreAffaire' ? total2 / 100 : total2
                });
            });
            /*Object.entries(data1).forEach(([date, values]) => {
                formattedData.push({
                    name: date, // Keep "DD/MM" format
                    Statutaire1: activeTab === 'chiffreAffaire'
                        ? ((values["1"] || 0) + (values["2"] || 0) + (values["3"] || 0) + (values["4"] || 0)) / 100
                        : (values["1"] || 0) + (values["2"] || 0) + (values["3"] || 0) + (values["4"] || 0),
                    Fiduciaire1: activeTab === 'chiffreAffaire'
                        ? (values["5"] || 0) / 100
                        : (values["5"] || 0),
                });
            });*/
            return formattedData;
        }
    };

    render() {
        const chartData = this.formatData();
        
        const { fetchingNbrCotisantByFormat, nbrCotisantByFormatCompareFetch, visibleKeys, year } = this.props;

        const legendPayload = [
            { value: year[0], type: 'line', color: '#000', id: 'Total1' },
            { value: year[0] - 1, type: 'line', color: '#464646b3', id: 'Total2' },
        ];

        return (
            nbrCotisantByFormatCompareFetch || fetchingNbrCotisantByFormat
                ?
                <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
                :
                <ResponsiveContainer width={"100%"} height={400}>
                    <ComposedChart data={chartData} margin={{ top: 10, right: 30 }}>
                        <CartesianGrid stroke="#D8DDE2" vertical={false} strokeDasharray="4" />
                        <XAxis dataKey="name" tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} />
                        <YAxis tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} allowDecimals={false} />
                        {/* <Tooltip contentStyle={{ borderRadius: '5px' }} itemStyle={{ textTransform: "capitalize" }} /> */}
                        <Tooltip content={({ active, payload, label }) => {
                            if (active) {
                                return (
                                    <div style={{
                                        backgroundColor: '#ffffff',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid gray'
                                    }}>
                                        <p>{label}</p>
                                        {
                                            payload && payload.filter(p => ["Total1", "Total2"].includes(p.dataKey)).map(p => (
                                                <p key={p.dataKey}
                                                    style={{ color: p.stroke, fontSize: '14px' }}>
                                                    {legendPayload.find(legend => legend.id === p.dataKey).value}: {this.props.activeTab === 'chiffreAffaire' ? formatAmount(p.value, false) : p.value}
                                                </p>
                                            ))
                                        }
                                    </div>
                                );
                            }
                            return null;
                        }} />
                        <Legend payload={legendPayload} iconType="line" />

                        {visibleKeys.includes('Fiduciaire') && <Bar dataKey="Fiduciaire2" stackId="b" fill="#ff7300" name="Fiduciaire 2024" opacity={0.5} />}
                        {visibleKeys.includes('Statutaire') && <Bar dataKey="Statutaire2" stackId="b" fill="#007bff" name="Statutaire 2024" opacity={0.5} />}
                        {visibleKeys.includes('Fiduciaire') && <Bar dataKey="Fiduciaire1" stackId="a" fill="#ff7300" name="Fiduciaire 2025" />}
                        {visibleKeys.includes('Statutaire') && <Bar dataKey="Statutaire1" stackId="a" fill="#007bff" name="Statutaire 2025" />}

                        <Line type="monotone" dataKey="Total1" stroke="#000" name="Total 2025" strokeWidth={2} isAnimationActive={true} animationDuration={2000} animationEasing="ease-out" />
                        <Line type="monotone" dataKey="Total2" stroke="#464646b3" name="Total 2024" strokeWidth={2} isAnimationActive={true} animationDuration={2500} animationEasing="ease-out" />
                    </ComposedChart>
                </ResponsiveContainer>
        );
    }
}

export default CotisantStatsComparison;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsChartLineCompare.js